import { getDefaultCurrency } from '@jutro/locale';
import _ from 'lodash';
import { CurrencyField } from '@jutro/legacy/components';
import { HOConstants, PAConstants } from 'wmic-pe-portals-utils-js';

const HIDDEN_COVERAGES = [
    HOConstants.waterDamageDeductibleCovPublicID,
    HOConstants.waterDefenceCovPublicID,
    PAConstants.autoPackageCovPublicID,
];

// eslint-disable-next-line no-secrets/no-secrets
/**
 * Groups coverages according to the supplied category map.
 *
 * @param {Object[]} coverages
 * @param {Object} categoryMap
 * @param {string|undefined} categoryMap.categoryName - Display name for the category. Defaults to `coverage.category_DisplayName_WMIC` when `categoryMap.coverageCategory` is supplied, otherwise defaults to the first matching coverage's name.
 * @param {string|undefined} categoryMap.coverageCategory - `coverage.category_WMIC` value belonging to this category.
 * @param {string[]} [categoryMap.coverageIDs] - `coverage.coverageUniqueID` values belonging to this category.
 * @param {string[]} [categoryMap.excludedCoverageIDs] - `coverage.coverageUniqueID` values to keep out of this category.
 * @param {boolean} [onlySelected=false] - Whether to include only selected coverages.
 * @returns {Object.<string, { categoryName: string, coverages: Object[] }>}
 */
function categorizeCoverages(coverages, categoryMap, onlySelected = false) {
    const filteredCoverages = onlySelected ? coverages.filter(coverage => coverage.selected) : coverages;
    const allCoverages = {};
    Object.entries(categoryMap).forEach(([categoryID, category]) => {
        const { coverageIDs = [], coverageCategory, excludedCoverageIDs = [] } = category;
        const coveragesInCategory = filteredCoverages.filter(
            coverage =>
                !excludedCoverageIDs.includes(coverage.coverageUniqueID) &&
                (coverageIDs.includes(coverage.coverageUniqueID) || coverageCategory === coverage.category_WMIC)
        );

        if (coveragesInCategory.length === 0) {
            return;
        }

        allCoverages[categoryID] = {
            categoryName:
                category.categoryName ??
                (coverageCategory ? coveragesInCategory[0].category_DisplayName_WMIC : coveragesInCategory[0].name),
            coverages: coveragesInCategory,
        };
    });
    return allCoverages;
}

function formatPremiumAmount(pAmount, pCurrency = getDefaultCurrency(), pShowFractions = true) {
    return pAmount !== 0 ? (
        <CurrencyField
            value={{
                amount: pAmount,
                currency: pCurrency,
            }}
            showFractions={pShowFractions}
            readOnly
        />
    ) : (
        ''
    );
}

function getPremiumAmount(coverage) {
    const amt = _.get(coverage, 'amount.amount', 0);
    const curr = _.get(coverage, 'amount.currency');

    return formatPremiumAmount(amt, curr);
}

function getProratedPremiumAmount(cost) {
    const amt = _.get(cost, 'proratedPremium.amount', 0);
    const curr = _.get(cost, 'proratedPremium.currency');

    return formatPremiumAmount(amt, curr);
}

function isUsableCov(cov) {
    return !HIDDEN_COVERAGES.includes(cov.publicID);
}

export default {
    categorizeCoverages,
    isUsableCov,
    getPremiumAmount,
    getProratedPremiumAmount,
    formatPremiumAmount,
};
